import React, { useContext } from "react";
import { Table, TableBody, TableHead, TableHeading } from "@thecb/components";
import { ROYAL_BLUE_VIVID } from "/constants/colors";
import { ThemeContext } from "styled-components";
import { ACTIVITY_TABLE_HEADINGS } from "/constants/activity_history_constants";
import ActivityRow from "./ActivityRow";

const ActivityTable = ({
  activities,
  customerManagement,
  linkColor = ROYAL_BLUE_VIVID
}) => {
  const FONT_SIZE = "0.875rem";
  const themeContext = useContext(ThemeContext);
  const { isMobile } = themeContext;
  const tableCellPadding = isMobile ? "0.75rem 1rem" : "1rem 1.5rem";

  return (
    <Table aria-label="Activity History Table">
      <TableHead>
        {ACTIVITY_TABLE_HEADINGS.map((heading, index) => (
          <TableHeading key={index} padding={tableCellPadding}>
            {heading}
          </TableHeading>
        ))}
      </TableHead>
      <TableBody>
        {activities.map(activity => (
          <ActivityRow
            key={activity.id}
            activity={activity}
            tableCellPadding={tableCellPadding}
            customerManagement={customerManagement}
            linkColor={linkColor}
            fontSize={FONT_SIZE}
          />
        ))}
      </TableBody>
    </Table>
  );
};

export default ActivityTable;
